import country from '@/utilities/country.js'

export default function checkCountryAccess(to, from, next) {
  const { allowed, redirect } = to.meta.countryAccess || {}

  if (!allowed || country.is(allowed) === true) {
    next()
  } else {
    next({ name: redirect || 'home' })
  }
}
